module.exports = __webpack_public_path__ + "img/sukamon.c304a257.svg";